/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkspaceDataForServiceAccount {
    getFixupPrototypeFunction() { return WorkspaceDataForServiceAccount.fixupPrototype; }

    static newInstance(model: Partial<WorkspaceDataForServiceAccount>): WorkspaceDataForServiceAccount {
        let obj = Object.assign(new WorkspaceDataForServiceAccount(), model);
        WorkspaceDataForServiceAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkspaceDataForServiceAccount>): WorkspaceDataForServiceAccount {
        if (!model) return null;
        return WorkspaceDataForServiceAccount.newInstance(<WorkspaceDataForServiceAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkspaceDataForServiceAccount) {
        if (!obj) return;

        models.WorkspaceDataForServiceAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkspaceDataForServiceAccount): boolean {
        Object.setPrototypeOf(obj, WorkspaceDataForServiceAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.workspace_details) {
            for (let val of this.workspace_details) {
                models.WorkspaceDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Id of the service account of the workspace
     */
    service_account_id: string;

    /**
     * list of all workspaces details associated with the service account
     */
    workspace_details: Array<models.WorkspaceDetails>;

}
